import React from "react";
import { Input } from "../../../../../../common/Input";
import { Select } from "../../../../../../common/Select";
import { EmployeePickerField } from "../../../../../../common/selectComponents/EmployeePicker";
import { MedicalClearancePicker } from "../../../../../../common/selectComponents/MedicalClearancePicker";
import SectionBadge from "../../ui/SectionBadge";
import PositionPickerField from "../../../../../../common/selectComponents/PositionPicker";
import DepartmentPickerField from "../../../../../../common/selectComponents/DepartmentPicker";
import VesselPickerField from "../../../../../../common/selectComponents/VesselPicker";

const EmployeeInfoTab = ({
  form,
  set,
  options,
  editable,
  errors,
  accessRules
}) => {
  const handleClearDepartment = () => {
    // RBL Logic: Clear department and position fields when department is cleared
    set('departmentId', ""); // this should be withDepartmentId temp but the backend is like this, so I've stay this this way,
    set('departmentName', ""); // same with id

    handleClearPosition();
  }
  const handleClearPosition = () => {
    set('tempPositionId', "");
    set('tempPositionName', "");
  }
  return (
    <div className="space-y-6">
      {accessRules?.allowAssignedTo && (
        <div className="rounded-xl border border-gray-200 bg-gray-50 p-6">
          <SectionBadge label="Employee Assignment" editable={editable} />
          <div className="grid grid-cols-1 gap-x-10 gap-y-4 lg:grid-cols-2">
            <div>
              <EmployeePickerField
                label="Via Captain (Person):"
                employeePersonalInformationId={form.assignedToEmployeePersonalInformationId}
                displayValue={form.assignedToData?.fullName || ""}
                onSelect={(emp) => {
                  set('assignedToEmployeePersonalInformationId', emp.id);
                  set('assignedToData', { fullName: emp.fullName, employeeId: emp.employeeId, position: emp.employeeInformationPositionDescription || "N/A" });
                }}
                onClear={() => {
                  set('assignedToEmployeePersonalInformationId', "");
                  set('assignedToData', null);
                }}
                viewMode={!editable}
                allowClear={true}
                isRequired={true}
                error={!!errors.assignedToEmployeePersonalInformationId}
                errorMessage={errors.assignedToEmployeePersonalInformationId}
              />
            </div>
          </div>
        </div>
      )}

      {accessRules?.allowMedicalClearance && !form?.isOnLeave && (
        <div className="bg-gray-50 p-6 rounded-xl border border-gray-200">
          <SectionBadge label="Employee Medical Clearance" editable={editable} />
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-10 gap-y-4">
            <MedicalClearancePicker
              label="Medical Clearance:"
              medicalClearanceId={form.medicalClearanceId}
              filterReferenceId={form.assignedEmployeePersonalInformationId}
              displayValue={form.medicalClearanceReferenceNumber || "--Select--"}
              onSelect={(m) => {
                set('medicalClearanceId', m.id);
                set('medicalClearanceReferenceNumber', m.referenceNumber);
              }}
              onClear={() => {
                set('medicalClearanceId', "");
                set('medicalClearanceReferenceNumber', "");
              }}
              viewMode={!editable}
              disabled={!form.assignedEmployeePersonalInformationId}
              isRequired={true}
              error={!!errors.medicalClearanceId}
              errorMessage={errors.medicalClearanceId}
            />
          </div>
        </div>
      )}

      {(accessRules?.allowEmployeeType ||
        accessRules?.allowDestination ||
        accessRules?.allowRegularTitle ||
        accessRules?.allowRegularVessel ||
        accessRules?.allowVesselType ||
        accessRules?.allowViaCaptain) && (
          <div className="rounded-xl border border-gray-200 bg-gray-50 p-6">
            <div className="space-y-4">
              <SectionBadge label="Employee Info" editable={false} />
              <div className="grid grid-cols-1 gap-x-10 gap-y-4 lg:grid-cols-2">
                {accessRules?.allowEmployeeType && (
                  <Input label="Employee Type:" value={form.currentTagging?.employeeType || ""} isDisabled={true} placeholder="-- No Data --" />
                )}
                {accessRules?.allowDestination && (
                  <Input label="Destination:" value={form.currentTagging?.destination || ""} isDisabled={true} placeholder="-- No Data --" />
                )}
                {accessRules?.allowRegularTitle && (
                  <Input label="Regular Title:" value={form.currentTagging?.regularTitle || ""} isDisabled={true} placeholder="-- No Data --" />
                )}
                {accessRules?.allowRegularVessel && (
                  <Input label="Regular Vessel:" value={form.currentTagging?.regularVessel || ""} isDisabled={true} placeholder="-- No Data --" />
                )}
                {/* {accessRules?.allowVesselType && (
                  <Input label="Vessel Type:" value={form.currentTagging?.vesselType || ""} isDisabled={true} placeholder="-- No Data --" />
                )} */}
                {accessRules?.allowViaCaptain && (
                  <Input label="Via Captain:" value={form.currentTagging?.viaCaptain || ""} isDisabled={true} placeholder="-- No Data --" />
                )}
              </div>
            </div>
          </div>
        )}

      {(accessRules?.allowTempEmployeeType ||
        accessRules?.allowTempClassification ||
        accessRules?.allowTempDepartment ||
        accessRules?.allowTempPosition ||
        accessRules?.allowTempVessel ||
        accessRules?.allowTempEmployment) && (
          <div className="rounded-xl border border-gray-200 bg-gray-50 p-6">
            <div className="space-y-4">
              <SectionBadge label="Temporary Assignment Fields" editable={editable} />

              <div className="grid grid-cols-1 gap-x-10 gap-y-4 lg:grid-cols-2">
                {accessRules?.allowTempEmployeeType && (
                  <Select
                    label="Temp Employee Type:"
                    options={options.employeeTypes}
                    value={form.tempEmployeeTypeId}
                    onChange={e => set('tempEmployeeTypeId', e.target.value)}
                    disabled={!editable}
                    placeholder="--Select Temp Employee Type--"
                    isRequired={true}
                    error={!!errors.tempEmployeeTypeId}
                    errorMessage={errors.tempEmployeeTypeId}
                  />
                )}

                {accessRules?.allowTempClassification && (
                  <Select
                    label="Temp Classified As:"
                    options={options.classifications}
                    value={form.classificationId}
                    onChange={e => {
                      set('classificationId', e.target.value);
                      handleClearDepartment();
                    }}
                    disabled={!editable}
                    placeholder="--Select Classification--"
                    isRequired={true}
                    error={!!errors.classificationId}
                    errorMessage={errors.classificationId}
                  />
                )}

                {accessRules?.allowTempDepartment && (
                  <DepartmentPickerField
                    label="Temp Unit / Department:"
                    departmentId={form.departmentId}
                    employeeTypeId={form.tempEmployeeTypeId}
                    displayValue={form.departmentName || ""}
                    onSelect={(dept) => {
                      set('departmentId', dept.id);
                      set('departmentName', dept.description);
                      handleClearPosition();
                    }}
                    onClear={() => {
                      handleClearDepartment();
                    }}
                    placeholder="--Select Unit / Department--"
                    viewMode={!editable}
                    disabled={!form.tempEmployeeTypeId}
                    allowClear={true}
                    isRequired={true}
                    error={!!errors.departmentId}
                    errorMessage={errors.departmentId}
                  />
                )}

                {accessRules?.allowTempPosition && (
                  <PositionPickerField
                    label="Temp Title:"
                    positionId={form.tempPositionId}
                    departmentId={form.departmentId}
                    isDepending={true}
                    displayValue={form.tempPositionName || ""}
                    onSelect={(pos) => { set('tempPositionId', pos.id); set('tempPositionName', pos.description); }}
                    onClear={() => handleClearPosition()}
                    placeholder="--Select Temp Title--"
                    viewMode={!editable}
                    allowClear={true}
                    isRequired={true}
                    error={!!errors.tempPositionId}
                    errorMessage={errors.tempPositionId}
                  />
                )}

                {accessRules?.allowTempVessel && (
                  <VesselPickerField
                    label="Temp Vessel:"
                    vesselId={form.tempVesselId}
                    displayValue={form.tempVesselCode || ""}
                    onSelect={(v) => { set('tempVesselId', v.id); set('tempVesselCode', v.code); }}
                    onClear={() => { set('tempVesselId', ""); set('tempVesselCode', ""); }}
                    viewMode={!editable}
                    allowClear={true}
                    isRequired={true}
                    error={!!errors.tempVesselId}
                    errorMessage={errors.tempVesselId}
                  />
                )}

                {accessRules?.allowTempEmployment && (
                  <Select
                    label="Temp Employment:"
                    options={options.employments}
                    value={form.employmentId}
                    onChange={e => set('employmentId', e.target.value)}
                    disabled={!editable}
                    isRequired={true}
                    error={!!errors.employmentId}
                    errorMessage={errors.employmentId}
                  />
                )}
              </div>
            </div>

          </div>
        )}

      {accessRules?.allowTempEmployeeStatus && form?.isOnLeave && (
        <div className="bg-gray-50 p-6 rounded-xl border border-gray-200">
          <div className="space-y-4">
            <SectionBadge label="Employee Status Field" editable={editable} />
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-10 gap-y-4">
              <Select
                label="Employee Status:"
                options={options.employeeStatusMaintenance}
                value={form.tempEmployeeStatusId}
                onChange={e => set('tempEmployeeStatusId', e.target.value)}
                disabled={!editable}
                placeholder="--Select Temp Employee Status--"
                isRequired={form?.isOnLeave}
                error={!!errors.tempEmployeeStatusId && form?.isOnLeave}
                errorMessage={form?.isOnLeave ? errors.tempEmployeeStatusId : null}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EmployeeInfoTab;